import "../css/main.scss";

// Veškerý kód běží po načtení DOM pro konzistentní selektory
// (Pokud je bundler vkládá na konec body, stále je to bezpečné.)
document.addEventListener("DOMContentLoaded", () => {
  const menuToggle = document.querySelector(".menu-toggle");
  const navMenu = document.querySelector(".nav-menu");
  const header = document.querySelector < HTMLElement > ".header-tmp";

  // Dynamický offset: výška headeru + malá rezerva (5–10px)
  const getScrollOffset = () => (header?.offsetHeight || 95) + 5;

  // Výchozí stav menu (zavřené)
  menuToggle?.classList.remove("open");
  navMenu?.classList.remove("active");

  function toggleMenu() {
    navMenu?.classList.toggle("active");
    menuToggle?.classList.toggle("open");
  }

  menuToggle?.addEventListener("click", toggleMenu);

  // Smooth scroll s dynamickým offsetem pro sticky header
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", (e) => {
      const targetId = anchor.getAttribute("href");
      if (!targetId || targetId === "#") return; // ignoruj prázdné odkazy
      const targetElement = document.querySelector(targetId);
      if (!targetElement) return;
      e.preventDefault();
      const elementPosition =
        targetElement.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - getScrollOffset();
      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
      // Zavři menu na mobilu po kliknutí na položku
      if (navMenu?.classList.contains("active")) toggleMenu();
    });
  });

  // Reakce na resize – podle potřeby by se offset přepočítal při každém kliknutí (už zajištěno) –
  // pokud by se výška headeru dynamicky měnila po scrollu, lze přidat listener.

  // Postupný fade-in: přidáme třídu .visible se zpožděním
  const animated = document.querySelectorAll(
    ".fade-in, section:not(.main-head), .letter-section"
  );
  animated.forEach((el, i) => {
    setTimeout(() => {
      el.classList.add("visible");
    }, i * 200);
  });

  // Dropdown hover s drobným zpožděním skrytí
  document.querySelectorAll(".has-dropdown").forEach((dropdown) => {
    let timeoutId;
    const panel = dropdown.querySelector(".dropdown");
    if (!panel) return;
    dropdown.addEventListener("mouseenter", () => {
      clearTimeout(timeoutId);
      panel.classList.add("open");
    });
    dropdown.addEventListener("mouseleave", () => {
      timeoutId = setTimeout(() => panel.classList.remove("open"), 100);
    });
  });
});
